import { render } from "./Legal.vue?vue&type=template&id=8de63f12&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"

import "./Legal.vue?vue&type=style&index=0&id=8de63f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de63f12"]])

export default __exports__